<script>
  import '@awesome.me/webawesome-pro/dist/components/spinner/spinner.js';

  let { loader, children, errorSnippet } = $props();
</script>

{#await loader()}
  <div class="status-container">
    <wa-spinner style="font-size: 3rem;"></wa-spinner>
  </div>
{:then data}
  {@render children(data)}
{:catch err}
  <div class="status-container">
    {#if errorSnippet !== null && errorSnippet !== undefined}
      {@render errorSnippet(err)}
    {:else}
      <p style="color: red;">Error: {err.message}</p>
    {/if}
  </div>
{/await}

<style>
  .status-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 200px;
  }
</style>